import axios from "axios";

import { ChainJobRequest, GetChainJobRequest, GetChainJobResponse } from "./chainJob.shemas";

export async function putCreateChainJob(body: ChainJobRequest) {
    return await axios.post<string>('/v1/chianjob/insert', body, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
        }
    });
}

export async function retrieveChainJob(params: GetChainJobRequest) {
    return await axios.get<GetChainJobResponse[]>('/v1/chianjob/get', {
        params: params,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
        }
    });
}